import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Modal,
  Button,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterRounded';
import FileIcon from "../../common/assests/file.png";
import Paginations from "../../common/pagination/Paginations";
import { useSelector } from "react-redux";
import { allResourcesListApi, resourcBlockApi } from "../../api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useConfirm } from "../../common/confirmDialog/useConfirm";
import configuration from "../../config/Config";
import { AdminTable, ActionCell } from "../../common/adminTable";

const ResourceAndArticle = () => {
  const { id } = useParams();
  const token = useSelector((state) => state?.user?.user?.token);
  const confirm = useConfirm();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resourceDataList, setResourceDataList] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [change, setChange] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleOpen = (event) => {
    setSelectedEvent(event);
    setOpen(true);
  };

  const handleResourcesList = async () => {
    try {
      setLoading(true);
      const response = await allResourcesListApi({ token, currentPage, id });
      setResourceDataList(response?.resources || []);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    handleResourcesList();
  }, [currentPage, change]);

  const handleClose = () => setOpen(false);

  const handleDelete = async (id) => {
    const confirmationMessage = await confirm({ title: "Delete Resource", description: "Are you sure you want to delete this resource?", confirmText: "Delete", destructive: true });
    if (!confirmationMessage) return;
    try {
      const status = "deleted";
      const response = await resourcBlockApi({ token, status, id });
      setChange(!change);
      toast.success(response?.message);
      setOpen(false);
    } catch (error) {
      toast.error(error?.message);
      console.log("error", error);
    }
  };

  const handlePublish = async (id) => {
    const status = selectedEvent.status === "active" ? "deactivated" : "active";
    const confirmationMessage = status === "active"
      ? "Are you sure, you want to publish this resource?"
      : "Are you sure, you want to unpublish this resource?";
    if (!await confirm({ title: status === "active" ? "Publish Resource" : "Unpublish Resource", description: confirmationMessage, confirmText: status === "active" ? "Publish" : "Unpublish" })) {
      return;
    }
    try {
      const response = await resourcBlockApi({ token, status, id });
      setChange(!change);
      toast.success(response?.message);
      setOpen(false);
    } catch (error) {
      toast.error(error?.message);
      console.log("error", error);
    }
  };

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  const columns = [
    {
      field: "picture",
      headerName: "Image",
      width: 70,
      renderCell: (row) => (
        <img
          src={row?.picture ? `${configuration.cdnFront}/${row.picture}` : FileIcon}
          alt="resource"
          style={{ height: 40, width: 40, borderRadius: "6px", objectFit: "cover" }}
        />
      ),
    },
    { field: "title", headerName: "Title", minWidth: 150, renderCell: (r) => r?.title || "-" },
    {
      field: "description",
      headerName: "Description",
      minWidth: 200,
      cellSx: { maxWidth: 300, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
      renderCell: (r) => r?.description || "-",
    },
    { field: "status", headerName: "Status", width: 100, renderCell: (r) => r?.status || "-" },
    {
      field: "__actions",
      headerName: "",
      width: 80,
      align: "right",
      renderCell: (row) => (
        <ActionCell
          actions={[
            {
              label: row?.status === "active" ? "Unpublish" : "Publish",
              icon: row?.status === "active" ? <LockIcon fontSize="small" /> : <LockOpenIcon fontSize="small" />,
              color: "#065F46",
              onClick: () => handleOpen(row),
            },
            {
              label: "Delete",
              icon: <DeleteOutlineIcon fontSize="small" />,
              color: "#EA001B",
              onClick: () => handleDelete(row._id),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <Box sx={{ mt: "40px", mb: "30px" }}>
      <Typography sx={{ fontSize: "20px", fontWeight: "500", color: "#362B24", fontFamily: "Heebo", mb: 2 }}>
        Resource & Articles
      </Typography>
      <AdminTable
        columns={columns}
        rows={resourceDataList}
        loading={loading}
        rowKey="_id"
        emptyText="No resources found"
      />
      <Paginations
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        disabled={loading}
      />

      {/* Resource Detail Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "80vw", sm: "80vw" },
            maxWidth: '630px',
            bgcolor: "#F5F5F5",
            borderRadius: "32px",
            boxShadow: 24,
            maxHeight: "80vh",
            p: 4,
            overflowY: "auto",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>Resource & Article Details</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          {selectedEvent && (
            <Box
              sx={{
                mt: '25px',
                width: { xs: "75vw", sm: "78vw" },
                maxWidth: '570px',
                bgcolor: "#FFF",
                borderRadius: "20px",
                boxShadow: "3px 2px 20px 0px rgba(0, 0, 0, 0.04)",
                p: 2,
              }}
            >
              <Box>
                <img
                  src={selectedEvent?.picture ? `${configuration.cdnFront}/${selectedEvent?.picture}` : FileIcon}
                  alt="Event"
                  style={{ width: "100%", maxHeight: '263px', borderRadius: "20px", marginTop: "15px" }}
                />
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: { xs: "column", sm: "row" }, gap: 2, mt: 3 }}>
                  <Typography sx={{ fontSize: "18px", fontWeight: "700", color: "#362B24", fontFamily: "Heebo" }}>
                    {selectedEvent?.title || ""}
                  </Typography>
                  <Box sx={{ borderRadius: '28px', background: '#362B24', width: '110px', height: '30px', display: 'flex', alignItems: 'center', padding: '0 8px', flexShrink: 0, gap: 1 }}>
                    <WatchLaterRoundedIcon sx={{ color: '#FFF', width: '18px', height: '18px' }} />
                    <Typography sx={{ color: '#FFF', fontSize: '10px' }}>
                      {selectedEvent?.updated_at
                        ? new Date(selectedEvent?.updated_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                        : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Typography sx={{ fontSize: "17px", fontWeight: "600", color: "#362B24", fontFamily: "Heebo", mt: 3 }}>
                  Description
                </Typography>
                <Typography sx={{ mt: 2, opacity: 0.5, fontFamily: 'Heebo', fontSize: { xs: '11px', sm: '13px' } }}>
                  {selectedEvent?.description || " "}
                </Typography>
              </Box>
            </Box>
          )}

          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap', mt: 3 }}>
            <Button
              onClick={() => handlePublish(selectedEvent?._id)}
              startIcon={selectedEvent?.status === "active" ? <LockIcon /> : <LockOpenIcon />}
              sx={{
                borderRadius: '12px',
                backgroundColor: selectedEvent?.status === "active" ? '#F0EEEC' : "#362B24",
                minWidth: '160px',
                height: '46px',
                color: selectedEvent?.status === "active" ? '#362B24' : "#FFF",
                fontFamily: 'Heebo',
                textTransform: 'none',
                fontWeight: 500,
                '&:hover': { backgroundColor: selectedEvent?.status === "active" ? '#E0DDDA' : "#2a2018" },
              }}
            >
              {selectedEvent?.status === "active" ? "Unpublish" : "Publish"}
            </Button>
            <Button
              onClick={() => handleDelete(selectedEvent?._id)}
              startIcon={<DeleteIcon />}
              sx={{
                borderRadius: '12px',
                backgroundColor: '#EA001B',
                minWidth: '160px',
                height: '46px',
                color: '#FFF',
                fontFamily: 'Heebo',
                textTransform: 'none',
                fontWeight: 500,
                '&:hover': { backgroundColor: '#c8001a' },
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ResourceAndArticle;
